import { House } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router';
import { PATHS } from '../shared/routing/paths.ts';
import { Button, ErrorState, Page } from '../shared/ui/index.ts';

/** Last line of defence: an unexpected error in a page never leaves a blank screen. */
export const RouteErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  console.error('[app] unhandled route error', error);
  return (
    <Page>
      <ErrorState
        title={t('app.crash.title')}
        description={t('app.crash.description')}
        onRetry={() => window.location.reload()}
        action={
          <Button asChild variant="ghost" icon={House}>
            <Link to={PATHS.home}>{t('app.crash.home')}</Link>
          </Button>
        }
      />
    </Page>
  );
};
